export default __webpack_public_path__ + "static/media/title-exclusive-right.6373f80b.png";